import { ArrowDownIcon } from "@/app/icons/arrow-down"
import { PriceWrapper } from "@/app/price"
import type { PriceValue } from "@anaconda/core/price/types"
import { Trans } from "@lingui/react/macro"

export function BuyCollectionButtonContent({ price }: { price: PriceValue }) {
  return (
    <div className="flex items-center justify-between md:min-w-[145px]">
      <div className="flex items-center gap-2">
        <div className="rounded-full bg-success p-1 text-black">
          <ArrowDownIcon className="[&&]:h-[10px] [&&]:w-[10px]" />
        </div>
        <span className="uppercase">
          <Trans>Buy</Trans>
        </span>
      </div>
      <span className="sr-only md:not-sr-only">
        <PriceWrapper currencyClassName="text-white" {...price} />
      </span>
    </div>
  )
}
